import { render } from "./employee_documents_tab.vue?vue&type=template&id=4c9486de"
import script from "./employee_documents_tab.vue?vue&type=script&lang=js"
export * from "./employee_documents_tab.vue?vue&type=script&lang=js"

import "./employee_documents_tab.vue?vue&type=style&index=0&id=4c9486de&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__